// extracted by mini-css-extract-plugin
module.exports = {"body":"Edit_body__2bTnq"};